import moment from "moment";

type xType = "day" | "days" | "week" | "month" | "year" | "date"

export function formatX(date, type: xType) {

    const x = moment.unix(date)
    switch (type) {
        case "day":
            return x.format("HH:mm")
        case "days":
            return x.format("ddd HH:mm")
        case "week":
            return x.format("ddd")
        case "month":
            return x.format("DD")
        case "year":
            return x.format("DD.MM.YY")
        case "date":
            return x.format("DD.MM.YY")

    }
}